
import {
  computed,
  ComputedRef,
  defineComponent,
  onBeforeMount,
  PropType,
  Ref,
  ref
} from "vue";
import "vue3-carousel/dist/carousel.css";
import { Carousel, Navigation, Pagination, Slide } from "vue3-carousel";
import {
  ContentComment,
  Course,
  CourseTrack
} from "../../../../domain/entities/entities";
import course from "../application/Course.vue";
import {
  dispatchErrorBox,
  formattedDuration,
  toLocaleDateTime
} from "../mixins";
import { RepositoryException } from "../../../../domain/exceptions/exceptions";
import { useStore } from "vuex";
import CommentsModal from "../application/DashboardComments/CommentsModal.vue";
import ContentFallback from "../application/moldure/ContentFallback.vue";
import ModalIntroductoryContent from "../application/ModalIntroductoryContent.vue";
import Comment from "../application/DashboardComments/Comment.vue";
import { dispatchError } from "../../utils/error_handling";
import { getOrderFromURL } from "../../utils/order_utils";
import { wrapLoading } from "../../utils/wrap_loading";
import { useRoute } from "vue-router";

export default defineComponent({
  components: {
    Carousel,
    Slide,
    Navigation,
    Pagination,
    course,
    CommentsModal,
    ContentFallback,
    ModalIntroductoryContent,
    Comment
  },

  props: {
    courseTrack: {
      type: Object as PropType<CourseTrack>,
      required: true
    }
  },

  setup(props) {
    const store = useStore();
    const route = useRoute();

    const courses = ref(Array<Course>());

    /** Todo: document this explaining where and how it's gonna be used. */
    const settings = {
      itemsToShow: 1,
      snapAlign: "center",
      wrapAround: false
    };

    /** Todo: explain what the heck is this. */
    const breakpoints = {
      320: {
        itemsToShow: 1.25
      },

      420: {
        itemsToShow: 1.5
      },
      470: {
        itemsToShow: 1.75
      },

      560: {
        itemsToShow: 2
      },

      630: {
        itemsToShow: 3
      },

      720: {
        itemsToShow: 3.5
      },

      820: {
        itemsToShow: 3
      },

      920: {
        itemsToShow: 3.25
      },

      1020: {
        itemsToShow: 3.5
      },

      1120: {
        itemsToShow: 4
      },

      1270: {
        itemsToShow: 5
      },

      1320: {
        itemsToShow: 6
      },
      1920: {
        itemsToShow: 7
      }
      // 2340: {
      //   itemsToShow: 9
      // }
    };

    /** Is what will be the title of the comment modal. */
    const commentModalTitle = ref("");

    const course = ref(new Course());

    const openModalIntroductoryContent: Ref<boolean> = ref(false);

    const comments: ComputedRef<ContentComment[]> = computed(
      () => store.getters["course_module/comments"]
    );

    const isCommentsModalOpen: Ref<boolean> = ref(false);

    onBeforeMount(async () => {
      await loadCourses();
    });

    async function loadCourses(): Promise<void> {
      if (!props.courseTrack.id) return;
      try {
        const order = getOrderFromURL(route);
        await wrapLoading(async () => {
          await store.dispatch("course_module/loadCoursesOfCourseTrack", {
            order: order,
            courseTrackID: props.courseTrack.id
          });
        });
      } catch (e) {
        await dispatchError(e);
      }
    }

    /** Enable the body overflow to let the user scroll the page after close some modal. */
    const enableBodyOverflow = () => {
      document.body.style.overflow = "auto";
    };

    /** Disable the body overflow to not let the user scroll the page behind some modal while is open. */
    const disableBodyOverflow = () => {
      document.body.style.overflow = "hidden";
    };

    /** Dispatch an action to open the comment modal on screen. */
    const openCommentsModal = async () => {
      disableBodyOverflow();
      isCommentsModalOpen.value = true;
    };

    /** Dispatch an action to open the comment modal on screen. */
    const closeCommentsModal = async () => {
      enableBodyOverflow();
      isCommentsModalOpen.value = false;
    };

    /** Dispatch an action to load the comments. */
    const loadContentCommentsById = async (course: Course) =>
      await store.dispatch("course_module/loadContentCommentsById", course.id);

    /** Display the modal with the comments about the course. */
    const loadCourseCommentsModal = async (course: Course) => {
      try {
        commentModalTitle.value = course.title;
        await openCommentsModal();
        await loadContentCommentsById(course);
      } catch (e) {
        if (e instanceof RepositoryException) {
          await dispatchErrorBox(e.message);
        } else {
          console.error(e);
          await dispatchErrorBox("Ocorreu um erro inesperado.");
        }
      }
    };

    const openIntroductoryContent = (_course: Course): void => {
      course.value = _course;
      openModalIntroductoryContent.value = true;
      disableBodyOverflow();
    };

    const closeModalIntroductoryContent = (): void => {
      openModalIntroductoryContent.value = false;
      enableBodyOverflow();
    };

    function isCardBlocked(course) {
      return Boolean(course.isBlocked);
    }

    return {
      courses,
      settings,
      breakpoints,
      openModalIntroductoryContent,
      isCommentsModalOpen,
      course,
      commentModalTitle,
      comments,
      isCardBlocked,
      closeModalIntroductoryContent,
      openIntroductoryContent,
      formattedDuration,
      loadCourseCommentsModal,
      closeCommentsModal,
      toLocaleDateTime
    };
  }
});
